/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
 */
export interface SendOrganizationIdentityVerificationRequestBeneficialOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'corporateRelationships': SendOrganizationIdentityVerificationRequestBeneficialOwnersInnerCorporateRelationshipsEnum;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'beneficialOwnerType': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'countryResidence': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
}

export const SendOrganizationIdentityVerificationRequestBeneficialOwnersInnerCorporateRelationshipsEnum = {
    hasRightOver50Per: 'HAS_RIGHT_OVER_50PER',
    hasRightOver25Per: 'HAS_RIGHT_OVER_25PER',
    hasControllingInfluenceOverBusinessActivity: 'HAS_CONTROLLING_INFLUENCE_OVER_BUSINESS_ACTIVITY',
    businessExecutor: 'BUSINESS_EXECUTOR'
} as const;

export type SendOrganizationIdentityVerificationRequestBeneficialOwnersInnerCorporateRelationshipsEnum = typeof SendOrganizationIdentityVerificationRequestBeneficialOwnersInnerCorporateRelationshipsEnum[keyof typeof SendOrganizationIdentityVerificationRequestBeneficialOwnersInnerCorporateRelationshipsEnum];


